var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5402 0.80324L7.02082 5.32266L2.50137 0.803216C2.29549 0.597337 1.56951 0.430487 1.01041 0.989592C0.451303 1.5487 0.618177 2.2747 0.824032 2.48055L5.3435 7.00002L0.824056 11.5195C0.618176 11.7253 0.451303 12.4513 1.01038 13.0104C1.56946 13.5695 2.29549 13.4026 2.50135 13.1968L7.02082 8.67729L11.5403 13.1968C11.7461 13.4026 12.4721 13.5695 13.0312 13.0104C13.5904 12.4513 13.4235 11.7253 13.2176 11.5194L8.69815 6.99995L13.2176 2.48048C13.4235 2.27465 13.5904 1.54865 13.0312 0.98952C12.4721 0.43039 11.7461 0.597386 11.5402 0.80324Z",
    fill: "#556BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4a2aa7dea50de96fbc43ce8260671ca2.svg";
export { ForwardRef as ReactComponent };